import React from 'react'
import { type PropsWithChildren } from 'react'
import { ThemeProvider } from 'styled-components'

import { themeSunpoint, themeWellmaxx } from '@helper/theme'

export function CouponItemContainer({
  children,
  type,
}: PropsWithChildren<{ type: string }>) {
  if (type === 'tan') {
    return <ThemeProvider theme={themeSunpoint}>{children}</ThemeProvider>
  }
  if (type === 'body') {
    return <ThemeProvider theme={themeWellmaxx}>{children}</ThemeProvider>
  }
  return children
}
